import classNames from "classnames";
import React, { useState, useRef } from "react";

function Accordion({ title, content, serialNum, active, toggleAccordion }) {
  const contentRef = useRef(null);

  return (
    <div className="flex flex-col">
      <div
        className={classNames(
          "flex items-center p-3 space-x-5 cursor-pointer  border-x-0 transition duration-300 border-b border-disableGray",
          {
            "hover:bg-gray-300": active,
            "bg-gray-200": !active,
          }
        )}
        onClick={toggleAccordion}
      >
        <div className="ml-5 text-xl font-bold">{active ? "-" : "+"}</div>
        <div className="font-medium text-[18px] leading-5.5 tracking-normal space-x-2 font-dm-sans">
          <span>{serialNum}.</span>
          <span>{title}</span>
        </div>
      </div>
      <div
        ref={contentRef}
        style={{
          maxHeight: active ? `${contentRef.current?.scrollHeight}px` : "0px",
          transform: active ? "translateY(0)" : "translateY(-10px)",
        }}
        className="overflow-hidden transition-all duration-700 ease-in-out"
      >
        <div
          className={
            "py-4 pl-8 text-md font-normal leading-7 tracking-normal text-midGray font-dm-sans "
          }
        >
          {content}
        </div>
      </div>
    </div>
  );
}

export default function CustomAccordion({ data = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <div className="border border-disableGray">
      {data.map((faq, index) => (
        <Accordion
          serialNum={index + 1}
          key={index}
          title={faq.heading}
          content={faq.description}
          dataLength={data?.length}
          toggleAccordion={() => toggleAccordion(index)}
          active={activeIndex === index}
        />
      ))}
    </div>
  );
}
